import { Dispatch, SetStateAction } from "react";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import { Modal, Button, Chip } from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function ViewAIHub({ open, onClose, setOpen }: ModalProps) {
  return (
    <Modal open={open} onClose={onClose} className="modal ai_hub_modal">
      <div className="modal-dialog">
        <div className="modal-body">
          {/* HEADER */}
          <div className="modal_header">
            <div className="left">
              <h2>Customer Satisfaction Drop</h2>
              <div className="chips">
                <Chip label="customer" size="small" className="chip customer" />
                <Chip label="active" size="small" className="chip active" />
              </div>
            </div>

            <button className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </button>
          </div>

          {/* DESCRIPTION */}
          <div className="section">
            <h6>Description</h6>
            <p>
              NPS score dropped from 72 to 58 over past month, primarily due to
              delivery delays.
            </p>
          </div>

          {/* DATA BLOCK */}
          <div className="section">
            <h6>Data</h6>
            <pre className="code_block">
{`{
  "nps_current": 58,
  "nps_previous": 72,
  "main_complaint": "delivery delays",
  "affected_orders_pct": 23
}`}
            </pre>
          </div>

          {/* RECOMMENDATIONS */}
          <div className="section">
            <h6>Recommendations</h6>
            <ul className="recommendations">
              <li><span>1</span> Review logistics partners</li>
              <li><span>2</span> Improve delivery estimates</li>
              <li><span>3</span> Proactive communication</li>
            </ul>
          </div>

          {/* GENERATED DATE */}
          <div className="generated">
            Generated: 12/11/2025, 9:45:48 PM
          </div>

          {/* FOOTER ACTIONS */}
          <div className="footer_actions">
            <Button className="btn btn_warning">Acknowledge</Button>
            <Button
              className="btn btn_success"
              startIcon={<CheckCircleOutlineIcon />}
            >
              Mark Resolved
            </Button>
            <Button
              className="btn btn_grey"
              startIcon={<ArchiveOutlinedIcon />}
            >
              Archive
            </Button>
            <Button className="btn btn_outline" onClick={() => setOpen(false)}>
              Close
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
